export default __webpack_public_path__ + "static/media/page404.c28bedcf.png";